import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformGroup } from './groups.transformers';
import { GroupsCollection } from './groups.types';

export function groupsReducer(
  state: CollectionStateSlice<GroupsCollection> = {},
  action: CollectionActions<GroupsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'groups') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<GroupsCollection>(
          state,
          transformIntoDocuments(result.groups, transformGroup),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
